import { Stack } from "@mui/material"
import { styled } from "@mui/material/styles"
import { red } from "@mui/material/colors"
import Block from "components/Block"
import { Body } from "components/styledFonts"


const Bold = styled('span')({
    fontSize: 14,
    fontWeight: 700,
})


const Warnning = () => (
    <Block>
        <Stack
            alignItems="center"
        >
            <Body sx={{ color: red[500] }}>※ご注意</Body>
            <Body>広報活動診断は、経営者・担当者の両方の診断入力が<Bold>すべて終わってから</Bold>『回答完了』ボタン押下をお願いします。</Body>
            <Body>『回答完了』ボタンを押した後は<Bold>編集ができなくなります</Bold>ので、経営者・担当者の片方がまだ未入力、または入力 途中の場合は『一次保存』ボタンをご選択ください。</Body>
        </Stack>
    </Block>
)

export default Warnning
